import keyMirror from 'keymirror';

export const MessageDialogs = keyMirror({
    BULK_EMAIL: null,
});

export const CategoryDialogs = keyMirror({
    SELECT: null
})

export const CommonDialogs = keyMirror({
    CONFIRM: null
});

export const CourseDialogs = keyMirror({
    RETAKE_COURSE: null,
});

export const ModuleDialogs = keyMirror({
    ASSET_ADD: null,

    SET_CODE: null,

    ENROLMENT_ADD: null,
    ENROLMENT_EDIT: null,
    ENROLMENT_DELETE: null,

    ENROLMENT_BY_FILTER_ADD: null,

    MODULE_EVENT_ASSIGN: null,
    MODULE_EVENT_SCORE: null,

    REMINDER_ADD: null,
    REMINDER_EDIT: null,

    TRAINER_ADD: null,

    ELEARNING_DIALOG: null,
    SWITCH_REGISTRATION_DIALOG: null,
});

export const EventDialogs = keyMirror({
    ATTENDEE_ADD: null,
    ATTENDEE_BULK_EMAIL: null,
    TRAINER_ADD: null
});

export const CertificateDialogs = keyMirror({
    FIELD_ADD: null,
    FIELD_EDIT: null
});

export const SystemDialogs = keyMirror({
    MESSAGE_DIALOG: null,
});

export const UserDialogs = keyMirror({
    USER_SKILL_DIALOG: null,
});

export const ComplianceDialogs = keyMirror({
    ASSIGN_USERS: null,
    COMPLIANCE_DELETE: null,
    COMPLIANCE_CLEAR_USERS: null
});

export const ReportDialogs = keyMirror({
    REPORT_SHARE: null,
    DOWNLOAD: null,
    SCHEDULE_ADD: null,
    SCHEDULE_EDIT: null
});

export const LabelDialogs = keyMirror({
    LABEL: null
});
